import {SOFT_NAV_STATE} from '@github-ui/soft-nav/states'
import {useSyncExternalStore} from 'react'

import {isOneCopilotBrowserTelemetryPathExcluded} from './copilot-ui-readiness'

const getServerPathname = () => ''
const getPathname = () => (typeof window === 'undefined' ? '' : window.location.pathname)
const subscribeNothing = () => () => undefined

function subscribe(listener: () => void) {
  if (typeof window === 'undefined') return () => undefined
  window.addEventListener('popstate', listener)
  document.addEventListener(SOFT_NAV_STATE.END, listener)
  return () => {
    window.removeEventListener('popstate', listener)
    document.removeEventListener(SOFT_NAV_STATE.END, listener)
  }
}

export function useOneCopilotBrowserTelemetryEnabled(featureEnabled: boolean): boolean {
  const currentPathname = useSyncExternalStore(subscribeNothing, getPathname, getServerPathname)
  const observeNavigation = featureEnabled && !isOneCopilotBrowserTelemetryPathExcluded(currentPathname)
  const pathname = useSyncExternalStore(
    observeNavigation ? subscribe : subscribeNothing,
    getPathname,
    getServerPathname,
  )
  return featureEnabled && !isOneCopilotBrowserTelemetryPathExcluded(pathname)
}
